var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHamburger = function SvgHamburger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "hamburger_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.892 10.284h52.216V6.258H5.892zm0 23.73h52.216v-4.027H5.892zm0 23.728h52.216v-4.026H5.892z",
    clipRule: "evenodd"
  })));
};
export { SvgHamburger as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTUuODkyIDEwLjI4NDFINTguMTA4VjYuMjU4MDZINS44OTJWMTAuMjg0MVpNNS44OTIgMzQuMDEzMUg1OC4xMDhWMjkuOTg3MUg1Ljg5MlYzNC4wMTMxWk01Ljg5MiA1Ny43NDIxSDU4LjEwOFY1My43MTYxSDUuODkyVjU3Ljc0MjFaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";